import { render, staticRenderFns } from "./RatingsToValidateWidget.vue?vue&type=template&id=f30c4e3a&scoped=true"
import script from "./RatingsToValidateWidget.vue?vue&type=script&lang=js"
export * from "./RatingsToValidateWidget.vue?vue&type=script&lang=js"
import style0 from "./RatingsToValidateWidget.vue?vue&type=style&index=0&id=f30c4e3a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30c4e3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f30c4e3a')) {
      api.createRecord('f30c4e3a', component.options)
    } else {
      api.reload('f30c4e3a', component.options)
    }
    module.hot.accept("./RatingsToValidateWidget.vue?vue&type=template&id=f30c4e3a&scoped=true", function () {
      api.rerender('f30c4e3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/dashboard/widgets/RatingsToValidateWidget.vue"
export default component.exports